import { ShoppingCart } from 'types/ShoppingCart';
import {
  getDiscountReasonByOrderIndex,
  getProductsInShoppingCart,
} from 'reducers/ShoppingCart';
import { getPayments } from 'reducers/Payments';
import { getSelectedPosID } from 'reducers/PointsOfSale';
import { getCurrentSalesDocument } from 'reducers/sales';
import { getSelectedCustomer } from 'reducers/customerSearch';
import { getVatRates } from 'reducers/vatRatesDB';
import { Customer } from 'types/Customer';

import { DEPayGroup, DEStartRequestType } from './DERequestType';

type ESR = Required<Required<DEStartRequestType['TraS']>['ESR']>;

type PosA = ESR['PosA'];
type PayA = ESR['PayA'];
type Ctm = ESR['Ctm'];

function getCtm(state): Ctm {
  const customer: Customer = getSelectedCustomer(state);
  return {
    CN: String(customer.id),
    Nam: customer.fullName ?? customer.companyName,
    Nam2: '',
    Cat: customer.groupName,
    Adr: customer.address,
    Adr2: customer.address2,
    Zip: customer.postalCode,
    City: customer.city,
    Ctry: customer.country,
    TaxId: customer.vatNumber,
  };
}
function getPayA(state): PayA {
  const payments = getPayments(state);
  return Object.values<any>(payments).map((pmt): PayA[number] => ({
    _: 'Pay',
    PayG: pmt.type === 'CASH' ? DEPayGroup.CASH : DEPayGroup.NONCASH,
    Amt: (Number(pmt.amount) * Number(pmt.currencyRate ?? 1)).toFixed(2),
    UID: pmt.referenceNumber,
    Dsc: pmt.type,
    CC: pmt.currencyCode ?? pmt.currency,
    FAmt: pmt.amount,
  }));
}

function getPosA(state): PosA {
  const shoppingCart: ShoppingCart = getProductsInShoppingCart(state);
  const vatRates = getVatRates(state);

  const positions: PosA = [];
  shoppingCart.forEach(item => {
    positions.push({
      _: 'Pos',
      Dsc: item.name,
      Pri: String(item.finalPriceWithVAT),
      Qty: String(item.amount),
      ID: String(item.productID),
      QtyU: item.unit,
      Cat: item.groupName,
      Amt: String(item.rowTotal),
      TaxG:
        vatRates.find(rate => Number(rate.id) === Number(item.vatrateID))
          ?.code ?? '?',
    });
    if (item.totalDiscountAmountWithVAT) {
      positions.push({
        _: 'Mod',
        Amt: `-${Number(item.totalDiscountAmountWithVAT).toFixed(2)}`,
        Dsc: getDiscountReasonByOrderIndex(item.orderIndex)(state)?.name,
        PN: String(item.rowNumber),
      });
    }
  });
  return positions;
}

export const getCurrentTransaction = (state): DEStartRequestType['TraS'] => {
  const posID = getSelectedPosID(state);
  const salesDoc = getCurrentSalesDocument(state);
  return {
    ESR: {
      TL: String(posID),
      TN: String(salesDoc.number ?? salesDoc.invoiceNo ?? 'new'),
      Ctm: getCtm(state),
      PayA: getPayA(state),
      PosA: getPosA(state),
    },
  };
};
